import * as React from 'react';
import { Product } from '~/Api/Product';
import { AeMaxPrice } from '~/Api/User/ProductGroup/AeMaxPrice';

export const ProductProvider: React.FunctionComponent<
	React.PropsWithChildren<{
		aeMaxPrice: AeMaxPrice | null;
		id: string;
		children(product: Product | null): React.ReactNode;
	}>
> = ({ aeMaxPrice, id, children }) => {
	const product = React.useMemo(
		() => aeMaxPrice?.products.find((candidate) => candidate.product.id === id)?.product ?? null,
		[aeMaxPrice, id]
	);
	return <>{children(product)}</>;
};

ProductProvider.displayName = 'AeMaxPrice.ProductProvider';
